






import {
  Component,
  Vue,
  Prop,
  AdvisorNavigation,
  ComponentStyle,
  ComponentStyleDefinition,
  QAFlowStepsNavigation
} from "@zoovu/runner-browser-api";

@Component({})
export default class PageSelectorSlider extends Vue {
  @Prop()
  navigation!: AdvisorNavigation;

  @ComponentStyle()
  componentStyle!: ComponentStyleDefinition;

  calculateProgressBarWidth() {
    const { type, navigation } = this.navigation.currentSection;
    if (type === "RESULTS_PAGE") {
      return { width: "100%" };
    }
    const { flowSteps, currentStepIndex } = navigation as QAFlowStepsNavigation;
    const numberOfSteps = flowSteps.length;
    const width = numberOfSteps ? (100 * currentStepIndex) / numberOfSteps : 0;
    return { width: `${width}%` };
  }
}
